export default [
    { //商品详情页面
        path: '/goods/goodsInfo/:id',
        name: 'GoodsInfo',
        component: () => import('@/views/goods/GoodsInfo.vue'),
        meta: {
            showTab: false,
            keepAlive: false
        }
    },
    { //商品订单列表页面
        path: '/goods/goodsList',
        name: 'GoodsList',
        component: () => import('@/views/goods/GoodsList.vue'),
        meta: {
            showTab: false,
            keepAlive: false
        }
    },
    { //新品推荐
        path: '/goods/newGoods',
        name: 'NewGoods',
        component: () => import('@/views/goods/NewGoods.vue'),
        meta: {
            showTab: false,
            keepAlive: false
        }
    },
    { //人气推荐
        path: '/goods/hotGoods',
        name: 'HotGoods',
        component: () => import('@/views/goods/HotGoods.vue'),
        meta: {
            showTab: false,
            keepAlive: false
        }
    },
    { //人气推荐
        path: '/goods/newProductList',
        name: 'newProductList',
        component: () => import('@/views/goods/NewProductList.vue'),
        meta: {
            showTab: false,
            keepAlive: false
        }
    }
];
